import { Euler, Object3D, Quaternion, Vector3 } from 'three';
import { ActionControllerEventName, ResourcesManager, Tween, Viewer, ViewerModule } from '@verybigthings/vbt-webvr-framework';
import { SinkViewer } from './SinkViewer';
import IconButtonComponent from '@verybigthings/vbt-webvr-framework/build/main/ts/components/IconButtonComponent';
import * as styleConfig from '../../styleConfig';
import { CircleSliderComponent, SlidingMode } from '@verybigthings/vbt-webvr-framework/build/main/ts/components/CircleSliderComponent';
import { PickingControllerEvents } from '@verybigthings/vbt-webvr-framework/build/main/ts/controls/PickingController';
import { PreparationPickingObjects } from "../../utils/PreparationPickingObjects";
export default class FlaskModule extends ViewerModule {
    constructor(model, table, uiContainer, level) {
        super();
        this.model = model;
        this.table = table;
        this.uiContainer = uiContainer;
        this.level = level;
        this.saltWeight = 0;
        this.numbCurrentWaterSection = 5;
        this.flaskTopPosition = new Vector3(22, -17, -8.4);
        this.uiObject.name = 'FlaskModule';
        this.defaultPosition = model.position.clone();
        this.flask = model.getObjectByName('flask');
        this.flask.scale.set(1.05, 1, 1.05);
        // this.addObject(this.uiContainer);
        this.table.add(this.wrapRotate = new Object3D());
        this.wrapRotate.name = 'wrapRotate';
        this.wrapRotate.add(model);
        this.wrapRotate.position.copy(this.model.position);
        this.salt = model.getObjectByName('salt_mount_flask');
        this.salt.geometry.translate(0, 1.07, 0);
        this.salt.scale.multiplyScalar(0.001);
        this.salt.position.y -= 1;
        this.model.position.set(0, 0, 0);
        this.shakedColor = this.model.getObjectByName('flask_water_1').material.color.clone();
        model.children.forEach((mesh, index) => {
            if (mesh.name.includes('flask_water')) {
                mesh.material = mesh.material.clone();
                mesh.material.opacity = 0;
                mesh.material.transparent = true;
                mesh.material.color.g = 0.55;
                mesh.visible = false;
            }
        });
        this.initWater();
    }
    setSaltWeight(saltWeight) {
        this.saltWeight = saltWeight;
        if (this.saltWeight > 6)
            this.shakedColor.g = 0.55;
    }
    initWater() {
        this.sink = new SinkViewer(0.02);
        this.model.add(this.sink.uiObject);
        this.sink.init();
        this.sink.uiObject.position.set(0, 1.3, 0.4);
    }
    visibilityShadow(visibility = true) {
        const pPlane = this.model.getObjectByName('pPlane');
        if (pPlane)
            pPlane.visible = visibility;
    }
    pourDistilledWater(watterLevel, minLevel, maxLevel) {
        this.wrapRotate.rotation.set(0, 0, 0);
        ResourcesManager.getAudioManger().getAudio('water_pouring_sound').play();
        if (watterLevel > 0.95)
            watterLevel = 1;
        this.numbCurrentWaterSection = Math.ceil(minLevel + watterLevel * (maxLevel - minLevel));
        this.numbCurrentWaterSectionNoCeil = minLevel + watterLevel * (maxLevel - minLevel);
        const currWaterSection = this.model.getObjectByName('flask_water_' + this.numbCurrentWaterSection);
        if (currWaterSection) {
            currWaterSection.visible = true;
            let newOpacity = Math.abs(this.numbCurrentWaterSection - 1 - (minLevel + watterLevel * (maxLevel - minLevel)));
            if (newOpacity > 0.95) {
                newOpacity = 1;
                currWaterSection.material.transparent = false;
                currWaterSection.material.opacity = newOpacity;
                if (this.numbCurrentWaterSection > 1) {
                    this.model.getObjectByName('flask_water_' + (this.numbCurrentWaterSection - 1)).material.visible = false;
                }
            }
        }
        if (!Viewer.controls.zController) {
            this.sink.toggle(true);
            this.sinkStopTimeout && clearTimeout(this.sinkStopTimeout);
            this.sinkStopTimeout = setTimeout(() => this.sink.toggle(false), 300);
        }
    }
    setWaterColorbySoltWeight(saltWeight) {
    }
    putInFlask() {
        this.model.position.set(-0.3, 5.5, 1.5);
        this.flyTo(new Vector3(-0.3, 5.1, 1.5));
    }
    initWaitApply() {
        this.actionController.once(ActionControllerEventName.click, this.model, () => this.fire('applied'));
    }
    flyTo(pos, time = 600, onComplete, object) {
        new Tween((object || this.wrapRotate).position)
            .to(pos.clone(), time)
            .easing(TWEEN.Easing.Linear.None)
            .onComplete(() => onComplete && onComplete())
            .start();
    }
    initDragAndDropLabel(goalModel) {
        const pointerLabelWrap = new Object3D();
        this.model.userData.tablePosition = this.model.position.clone();
        this.actionController.once(ActionControllerEventName.click, this.model, () => {
            if (Viewer.controls.zController)
                return;
            // const pointerLabelWrap = new Object3D();
            pointerLabelWrap.add(this.model);
            // TODO
            // this.model.userData.tablePosition = this.model.position.clone();
            this.model.position.y = 1;
            Viewer.pointerController.setObject(pointerLabelWrap);
            this.visibilityShadow(false);
            this.actionController.once(ActionControllerEventName.click, goalModel, () => {
                Viewer.pointerController.setObject(null);
                this.wrapRotate.add(this.model);
                this.model.scale.set(1, 1, 1);
                this.wrapRotate.position.set(2.9, 4.43, 0.23);
                this.wrapRotate.rotateZ(1);
                this.model.position.y = -0.93;
                this.pourIntoResultJar();
            });
        });
        if (this.level.lobby.app.zSpacePickingController) {
            PreparationPickingObjects.saveObjectState(this.model);
            this.level.lobby.app.zSpacePickingController.on(PickingControllerEvents.PICKED, this.model, () => {
                if (!this.level.interaction)
                    return;
                Viewer.scene.add(this.model);
                this.visibilityShadow(false);
                this.level.lobby.app.zSpacePickingController.once(PickingControllerEvents.RELEASED, this.model, () => {
                    const distanceToResultJar = this.model.getWorldPosition(new Vector3()).distanceTo(goalModel.getWorldPosition(new Vector3()));
                    if (distanceToResultJar < 1.6) {
                        this.actionController.off(ActionControllerEventName.click, this.model);
                        this.level.lobby.app.zSpacePickingController.off(PickingControllerEvents.PICKED, this.model);
                        this.wrapRotate.add(this.model);
                        this.model.position.copy(this.model.userData.tablePosition);
                        this.model.rotation.set(0, 0, 0);
                        this.model.scale.setScalar(1);
                        this.wrapRotate.position.set(2.9, 4.43, 0.23);
                        this.wrapRotate.rotateZ(1);
                        this.model.position.y = -0.93;
                        this.pourIntoResultJar();
                    }
                    else {
                        PreparationPickingObjects.flyObjectToPrevState(this.model);
                    }
                });
            });
        }
    }
    pourIntoResultJar(time = 1600, onComplete) {
        ResourcesManager.getAudioManger().getAudio('water_pouring_sound').play();
        const startRotate = this.wrapRotate.rotation.z;
        const water_result_jar = this.table.getObjectByName('water_result_jar');
        water_result_jar.visible = true;
        water_result_jar.material.color.copy(this.shakedColor);
        new Tween({ alpha: 0 })
            .to({ alpha: 1 }, time)
            .easing(TWEEN.Easing.Linear.None)
            .onUpdate((alpha) => {
            water_result_jar.scale.y = alpha;
            this.wrapRotate.rotation.z = startRotate + alpha;
        })
            .onComplete(() => {
            this.model.children.forEach(mesh => {
                if (mesh.name.includes('flask_water')) {
                    mesh.material = mesh.material.clone();
                    mesh.material.opacity = 0;
                    mesh.material.transparent = true;
                }
            });
            this.setDefaultPositionRotation();
        })
            .start();
    }
    setDefaultPositionRotation() {
        // this.table.add(this.model);
        this.flyTo(new Vector3(2.9, 6, 0.23), 400, () => {
            this.flyTo(new Vector3(), 1000);
            new Tween(this.model.position)
                .to(this.defaultPosition.clone(), 1000)
                .easing(TWEEN.Easing.Linear.None)
                .onComplete(() => {
                this.visibilityShadow(true);
                this.fire('flask_is_back');
            })
                .start();
        });
        this.rotateTo(new Euler(), 500);
    }
    rotateTo(newEuler, time = 600, onComplete) {
        const oldQuaternion = this.wrapRotate.quaternion.clone();
        const newQuaternion = new Quaternion().setFromEuler(newEuler);
        new Tween({ alpha: 0 })
            .to({ alpha: 1 }, time)
            .easing(TWEEN.Easing.Linear.None)
            .onUpdate((alpha) => {
            const quat = oldQuaternion.clone().slerp(newQuaternion.clone(), alpha);
            this.wrapRotate.quaternion.copy(quat);
        })
            .onComplete(() => onComplete && onComplete())
            .start();
    }
    initShake() {
        if (Viewer.controls.zController) {
            let onPicked, onMove, onRelease;
            const position = this.model.parent.position.clone();
            let startColor = this.model.getObjectByName('flask_water_1').material.color.clone();
            this.level.lobby.app.zSpacePickingController.on(PickingControllerEvents.PICKED, this.model.parent, onPicked = () => {
                this.visibilityShadow(false);
                let distanceMoved = 0, oldPosition = this.model.parent.position.clone();
                this.level.lobby.app.zSpacePickingController.on(PickingControllerEvents.MOVED, this.model.parent, onMove = () => {
                    distanceMoved += this.model.parent.position.clone().distanceTo(oldPosition);
                    this.model.children.forEach(mesh => {
                        if (mesh.name.includes('flask_water')) {
                            mesh.material.color.copy(startColor.clone().lerp(this.shakedColor.clone(), distanceMoved / 50));
                        }
                    });
                    const waterSection = this.model.getObjectByName('flask_water_' + this.numbCurrentWaterSection);
                    waterSection.material.opacity = 1;
                    // completed
                    if (distanceMoved > 50) {
                        this.level.lobby.app.zSpacePickingController.off(PickingControllerEvents.PICKED, this.model.parent, onPicked);
                        this.level.lobby.app.zSpacePickingController.off(PickingControllerEvents.MOVED, this.model.parent, onMove);
                        this.salt.scale.set(0.01, 0.01, 0.01);
                        this.fire('flask_shaked');
                    }
                });
                this.level.lobby.app.zSpacePickingController.once(PickingControllerEvents.RELEASED, this.model.parent, () => {
                    this.level.lobby.app.zSpacePickingController.off(PickingControllerEvents.MOVED, this.model.parent, onMove);
                    this.rotateTo(new Euler(), 500);
                    this.flyTo(position, 600, () => this.visibilityShadow(true));
                    this.model.children.forEach(mesh => {
                        if (mesh.name.includes('flask_water')) {
                            mesh.material.color.copy(startColor);
                        }
                    });
                });
            });
        }
        else {
            let rotateStarted = false;
            // BURNER
            this.shakeFlask = new CircleSliderComponent({
                mode: SlidingMode.onlyClockwise,
                diameter: 2.5,
                magnetOnSides: 0.05,
                spaceBetweenObjects: 0.02,
                picker: new IconButtonComponent({
                    text: '',
                    diameter: 0.6,
                    background: styleConfig.SLIDER_PICKER_COLOR.getStyle(),
                    textColor: styleConfig.SLIDER_PICKER_TEXT_COLOR.getStyle(),
                }),
                filledPart: {
                    width: 0.35,
                    mainColor: styleConfig.SLIDER_FILLED_COLOR
                },
                unfilledPart: {
                    width: 0.35,
                    border: 0.1,
                    mainColor: styleConfig.SLIDER_UNFILLED_COLOR,
                    borderColor: styleConfig.SLIDER_BORDER_COLOR
                }
            });
            this.shakeFlask.uiObject.position.y = -2.2;
            this.shakeFlask.uiObject.position.z = 3.24;
            this.shakeFlask.uiObject.userData.pcPosition = this.shakeFlask.uiObject.position.clone();
            if (Viewer.controls.zController) {
                this.shakeFlask.uiObject.position.set(0, 0, 0);
                // @ts-ignore
                this.shakeFlask.uiObject.scale.setScalar(2);
            }
            let startColor = this.model.getObjectByName('flask_water_1').material.color.clone();
            this.shakeFlask.on('change', (event) => {
                if (!rotateStarted)
                    rotateStarted = true;
                this.wrapRotate.rotation.y -= 0.06;
                this.model.children.forEach(mesh => {
                    if (mesh.name.includes('flask_water')) {
                        mesh.material.color.copy(startColor.clone().lerp(this.shakedColor.clone(), event.data));
                    }
                });
                const waterSection = this.model.getObjectByName('flask_water_' + this.numbCurrentWaterSection);
                waterSection.material.opacity = 1;
            });
            this.shakeFlask.once('completed', () => {
                this.model.rotateX(0.1);
                this.shakeFlask.dispose();
                this.salt.scale.set(0.01, 0.01, 0.01);
                this.flyTo(this.defaultPosition, 300, () => {
                    this.visibilityShadow(true);
                    this.fire('flask_shaked');
                });
            });
            this.actionController.once(ActionControllerEventName.click, this.model, () => {
                // PLAY SHAKE SOUND
                // enableInteraction = false;
                this.visibilityShadow(false);
                this.model.rotateX(-0.1);
                const shakePosition = this.defaultPosition.clone();
                shakePosition.y += 0.2;
                this.flyTo(shakePosition, 300, () => this.uiContainer.add(this.shakeFlask.uiObject));
            });
        }
    }
    show(isVisible = true) {
        this.uiObject.visible = isVisible;
    }
}
